var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[(_vm.currentUser)?[_c('core-drawer'),_vm._v(" "),_c('core-toolbar'),_vm._v(" "),_c('core-view',[_vm._t("default")],2)]:[_vm._t("default")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }